/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pol_Status_AllowedInputs */

const en_pol_status_allowed = /** @type {(inputs: Pol_Status_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allowed`)
};

const id_pol_status_allowed = /** @type {(inputs: Pol_Status_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diizinkan`)
};

/**
* | output |
* | --- |
* | "Allowed" |
*
* @param {Pol_Status_AllowedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pol_status_allowed = /** @type {((inputs?: Pol_Status_AllowedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pol_Status_AllowedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pol_status_allowed(inputs)
	return en_pol_status_allowed(inputs)
});